import Axios from '@/utils/Axios'
import Axios2 from '@/utils/Axios2'

export const getStaNumApi = (deptId) =>
  Axios.ajax({
    method: 'get',
    url: '/monitor/riskStatus/statistic',
    params: {deptId}
  })

export const getUserMenusApi = () =>
  Axios2.ajax({
    method: 'get',
    url: '/api/v1/user/getUserMenus',
    headers:{
      ClientType: 'ADMIN'
    }
  })

export const getUserInfoApi = () =>
  Axios.ajax({
    method: 'post',
    url: 'user/getUserInfo',
    headers:{
      ClientType: 'ADMIN'
    }
  })

export const getRiskListApi = ({ page, pageSize, deptId, alertLevel}) =>
  Axios.ajax({
    method: 'post',
    url: '/portal/realtimeRiskMonitorSitePage',
    data: {
      pageNum:page,
      showNum:pageSize,
      deptId,
      alertLevel
    }
  })

export const getRiskPointApi = ({ deptId, alertLevel, page = 1, size = 500 }) =>
  Axios.ajax({
    method: 'get',
    url:   '/monitor/queryList',
    params: { deptId, pageNum: page, showNum: size, alertLevel }
  })

export const riskStatusApi = (deptId) =>
  Axios.ajax({
    method: 'get',
    url:   '/monitor/riskStatus/statistic',
    params: { deptId }
  })

export const getHiddenEquipmentApi = (deptId) =>
  Axios2.ajax({
    method: 'get',
    url: 'api/v1/risk/device/statisticByType',
    params: { deptId }
  })

export const getNewTimeListApi = (deptId) =>
  Axios.ajax({
    method: 'post',
    url: '/portal/lastRisks',
    params: { deptId }
  })

export const getQueryRealtimeListApi = (deptId) =>
  Axios2.ajax({
    method: 'get',
    url: '/api/v3/monitor/queryList',
    params:{
      deptId,
      pageNum: 1,
      showNum: 500
    }
  })

export const getTreeApi = () =>
  Axios.ajax({
    method: 'get',
    url: '/dept/getDeptTree'
  })

export const getDayRiskDataApi = (deptId) =>
  Axios.ajax({
    method: 'post',
    url: '/portal/riskTypeCount',
    data:{ deptId }
  })

export const getLastMonthApi = (yearMonth, deptId) =>
  Axios.ajax({
    method: 'post',
    url: '/portal/deptMonthEnergyProportion',
    data: {
      yearMonth, deptId
    }
  })

export const getAllEnergyDataApi = () =>
  Axios.ajax({
    method: 'post',
    url: '/energy/deptEnergyTotal'
  })

export const searchEnergyDataApi = (type, date, deptId) => {
  const cfg = {
    method: 'post',
    data: { deptId }
  }
  switch (type){
    case 0:
      cfg.url = '/portal/deptHourEnergyTrendTotal'
      cfg.data.localDate = date
      break
    case 1:
      cfg.url = '/portal/deptDayEnergyTrendTotal'
      cfg.data.yearMonth = date
      break
    case 2:
      cfg.url = '/portal/deptMonthEnergyTrendTotal'
      cfg.data.year = date
      break
  }
  return Axios.ajax(cfg)
}

export const getMonthDataApi = (yearMonth, deptId) =>
  Axios.ajax({
    method: 'post',
    url: '/portal/deptMonthEnergyProportion',
    data: { yearMonth, deptId }
  })

export const getEnterpriseStatisticApi = () =>
  Axios2.ajax({
    method: 'get',
    url: 'api/v1/enterprise/statistic'
  })

/**
 * 监测点分页查询（v3）——首页饼图下钻用
 * @param {Object} params { deptId, riskLevel, disposed, pageNum, showNum }
 */
export const getMonitorSitePageApi = (params) =>
  Axios2.ajax({
    method: 'get',
    url: 'api/v3/monitor/queryList',
    params
  })
